var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.655273C4.48 0.655273 0 5.13527 0 10.6553C0 16.1753 4.48 20.6553 10 20.6553C15.52 20.6553 20 16.1753 20 10.6553C20 5.13527 15.52 0.655273 10 0.655273ZM11 15.6553H9V9.65527H11V15.6553ZM11 7.65527H9V5.65527H11V7.65527Z",
    fill: "#002951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.de6227b5b885b84ef159d2513ffd2c74.svg";
export { ForwardRef as ReactComponent };